import type { ClaimResponse } from './claim-response';

export const claimResponseValidatedNotPaid: ClaimResponse = {
  MedicalAidMessage: {
    '@Version': '6.0.0',
    Claim: {
      Transaction: {
        ReferenceNum: '22083014341085837bgcuk',
        DataSet: '01',
        InvoiceNum: 'MD05875592208-00037',
      },
      Details: {
        ClaimFinancials: {
          TotalClaimedAmt: '45590',
          TotalPaidProvAmt: '41740',
          BalanceOutstanding: '3850',
        },
        LineItems: [
          {
            UniqueID: '0',
            StatusCode: '6',
            StatusDesc: 'Validated by Medical Aid',
            MALineRefNum: 'B2IBFFNBTAL3',
            Editable: 'No',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '1630',
              MAPayable: '1630',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '0',
                Desc: 'No Error',
              },
            ],
          },
          {
            UniqueID: '1',
            StatusCode: '6',
            StatusDesc: 'Validated by Medical Aid',
            MALineRefNum: 'B2IBFFNBTAL3',
            Editable: 'No',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '43960',
              MAPayable: '40110',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '0',
                Desc: 'No Error',
              },
            ],
          },
        ],
        Responses: [
          {
            '@Type': 'Reason',
            Code: '0',
            Desc: 'Accepted',
          },
        ],
      },
    },
  },
};
